import { render, staticRenderFns } from "./BaseFormFile.vue?vue&type=template&id=0d91b709&scoped=true"
import script from "./BaseFormFile.vue?vue&type=script&lang=js"
export * from "./BaseFormFile.vue?vue&type=script&lang=js"
import style0 from "./BaseFormFile.vue?vue&type=style&index=0&id=0d91b709&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d91b709",
  null
  
)

export default component.exports